
export default {
  props: ['disabled'],
  computed: {
    orderId(){
      return this.$store.getters.orderId
    },
    accessToken(){
      return this.$store.getters.accessToken
    },
    queryParams(){
      const utmParams = this.$store.state.utmParams;
      if (utmParams && Object.keys(utmParams).length) {
        const queryParams = Object.entries(utmParams)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
        return `&${queryParams}`
      } else return ''
    },
    checkoutUrl(){
      return `${this.$config.commerceLayerCheckoutUrl}/${this.orderId}?accessToken=${this.accessToken}${this.queryParams}`
    }
  }
}
